import { includes, values } from 'lodash/fp';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { push } from 'connected-next-router';
import getIncomeTypeFromScale from '@ahmdigital/logic/lib/utils/get-income-type-from-scale';
import moment from 'moment';

import {
  ADDRESS_CHANGE,
  CONTINUOUS_COVER_CHANGE,
  DATE_OF_BIRTH_CHANGE,
  EMAIL_CHANGE,
  FREQUENCY_CHANGE,
  HAS_REFINED_PRICE,
  HAS_SET_BASIC_DETAILS_CHANGE,
  HOSPITAL_CHANGE,
  HOSPITAL_EXCESS_CHANGE,
  INCOME_CHANGE,
  INCOME_TIER_CHANGE,
  INCOME_TYPE_CHANGE,
  LAST_VIEWED_PRODUCT_CHANGE,
  PAYMENT_METHOD_CHANGE,
  PRODUCT_CHANGE,
  PRODUCT_TYPE_CHANGE,
  REBATE_CHANGE,
  SCALE_CHANGE,
  STATE_CHANGE,
  SWITCHING_CHANGE,
} from '../action-types';
import constants from '../../ahm-constants';
import ProductService from '../../models/product';

export type CustomerActionType = {
  customer: {
    changeHasRefinedPrice: (hasRefinedPrice: boolean) => void;
    changeHospitalExcess: (hospitalExcess: string) => void;
    changeIncomeType: (incomeType: string) => void;
    changeDateOfBirth: (dateOfBirth: string, memberRelationship: string) => void;
    changeRebate: (hasRebate: boolean) => void;
    changeIncomeTier: (incomeTier: string) => void;
    changeState: (state: string) => void;
    changeScale: (scale: string) => void;
    changeFrequency: (frequency: string) => void;
    changeProductType: (productType: string) => void;
    changeLastViewedProduct: (productId: string) => void;
  };
};

// @ts-expect-error - Automatic, Please fix when editing this file
function changeAddress(address) {
  return {
    address,
    type: ADDRESS_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
const changeEmail = (email) => ({
  payload: email,
  type: EMAIL_CHANGE,
});

// @ts-expect-error - Automatic, Please fix when editing this file
function changeContinuousCover(continuous, memberRelationship) {
  return {
    continuous,
    relationship: memberRelationship,
    type: CONTINUOUS_COVER_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeDateOfBirth(dateOfBirth, memberRelationship) {
  return {
    dateOfBirth: moment(dateOfBirth, constants.DATE_FORMAT.STANDARD, true),
    relationship: memberRelationship,
    type: DATE_OF_BIRTH_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeFrequency(frequency) {
  return {
    frequency,
    type: FREQUENCY_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeHasRefinedPrice(hasRefinedPrice) {
  return {
    hasRefinedPrice,
    type: HAS_REFINED_PRICE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeHasSetBasicDetails(hasSetBasicDetails) {
  return {
    hasSetBasicDetails,
    type: HAS_SET_BASIC_DETAILS_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeHospitalExcess(hospitalExcess) {
  // @ts-expect-error - Automatic, Please fix when editing this file
  return (dispatch, getState) => {
    const products = getState()?.product?.data;

    dispatch({
      hospitalExcess,
      products,
      type: HOSPITAL_EXCESS_CHANGE,
    });
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeIncome(income) {
  return {
    income,
    type: INCOME_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeIncomeTier(incomeTier) {
  return {
    incomeTier,
    type: INCOME_TIER_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeIncomeType(incomeType) {
  return {
    incomeType,
    type: INCOME_TYPE_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changePaymentMethod(method) {
  return {
    method,
    type: PAYMENT_METHOD_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeRebate(rebate) {
  return {
    rebate,
    type: REBATE_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeScale(scale) {
  // @ts-expect-error - Automatic, Please fix when editing this file
  return (dispatch, getState) => {
    const cartProduct = getState()?.cart?.product;

    if (cartProduct.type === constants.PRODUCT_TYPE.COMBINED && !ProductService.isAvailableFor(cartProduct, scale)) {
      dispatch({
        product: null,
        type: HOSPITAL_CHANGE,
      });
    }

    if (
      includes(cartProduct.type, [constants.PRODUCT_TYPE.PACKAGE, constants.PRODUCT_TYPE.HOSPITAL]) &&
      !ProductService.isAvailableFor(cartProduct, scale)
    ) {
      dispatch({
        product: {},
        type: PRODUCT_CHANGE,
      });
    }

    dispatch({
      incomeType: getIncomeTypeFromScale(scale),
      type: INCOME_TYPE_CHANGE,
    });

    // Change the scale regardless.
    return dispatch({
      scale,
      type: SCALE_CHANGE,
    });
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeState(state) {
  return {
    state,
    type: STATE_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeLastViewedProduct(productId) {
  return {
    lastViewedProduct: productId,
    type: LAST_VIEWED_PRODUCT_CHANGE,
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeProductType(productType) {
  // @ts-expect-error - Automatic, Please fix when editing this file
  return (dispatch, getState) => {
    const routerLocation = getState()?.router?.location?.pathname;

    const productTypeUrls = {
      [PRODUCT_TYPE.PACKAGE]: constants.URLS.SALES.PRODUCT_LISTING_PACKAGES,
      [PRODUCT_TYPE.HOSPITAL]: constants.URLS.SALES.PRODUCT_LISTING_HOSPITAL,
      [PRODUCT_TYPE.EXTRAS]: constants.URLS.SALES.PRODUCT_LISTING_EXTRAS,
    };

    const isProductListingPage = includes(routerLocation, values(productTypeUrls));

    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ package: any; hospital: any; extras: any; }'.
    if (isProductListingPage && productTypeUrls[productType] !== routerLocation) {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ package: any; hospital: any; extras: any; }'.
      dispatch(push(productTypeUrls[productType]));
    }

    return dispatch({
      productType,
      type: PRODUCT_TYPE_CHANGE,
    });
  };
}

// @ts-expect-error - Automatic, Please fix when editing this file
function changeSwitching(switching) {
  return {
    switching,
    type: SWITCHING_CHANGE,
  };
}

export default {
  changeAddress,
  changeContinuousCover,
  changeDateOfBirth,
  changeEmail,
  changeFrequency,
  changeHasRefinedPrice,
  changeHasSetBasicDetails,
  changeHospitalExcess,
  changeIncome,
  changeIncomeTier,
  changeIncomeType,
  changeLastViewedProduct,
  changePaymentMethod,
  changeProductType,
  changeRebate,
  changeScale,
  changeState,
  changeSwitching,
};
